export const resolvers = {
  Query: {},
  Mutation: {},
};
